<template>
  <vs-alert
    class="app-alert"
    :class="type"
    :color="color"
    :iconPack="iconPack"
    :icon="icon"
    :active.sync="isActive"
    :closable="closable"
    :close-icon="closeIcon">
    <slot>
        <h4 class="titlex vs-alert--title">{{ title }}</h4>
        {{ text }}
    </slot>
  </vs-alert>
</template>

<script>
export default {
  name: 'AppAlert',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    iconPack: {
      type: String,
      default: 'material-icons',
    },
    icon: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: true,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    closeIcon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'linear', 'linear-center', 'default-start'].includes(value);
      },
    },
  },
  computed: {
    isActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit('update:active', val);
      },
    },
  },
};
</script>

<style lang="scss">
.app-alert.default .vs-alert {
    justify-content: start !important;

    .vs-icon {
        padding-top: 18px !important;
        align-items: start !important;
    }

    .vs-alert--title {
        padding-left: 0 !important;
    }
}

.app-alert.default-start .vs-alert {
    justify-content: start !important;
    align-items: flex-start !important;

    .vs-alert--title {
        padding-left: 0 !important;
    }
}

.app-alert.linear-center .vs-alert {
    justify-content: center !important;
}

.con-vs-alert.app-alert {
  height: auto !important;
}
</style>
